<template>
    <div class="payment-box">
      <h2>Ödeme Sayfası</h2>
      <div v-if="job">
        <p><strong>Belge:</strong> {{ job.file_name }}</p>
        <p><strong>Fiyat:</strong> ₺{{ job.admin_price }}</p>
        <p><strong>Durum:</strong> {{ formatStatus(job.status) }}</p>
  
        <button class="btn" @click="completePayment">Ödemeyi Tamamla</button>
      </div>
      <div v-else>
        <p>Yükleniyor...</p>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { getToken } from '@/utils/auth'  
  
  const route = useRoute()
  const router = useRouter()
  const job = ref(null)
  const baseURL = process.env.VUE_APP_API_URL
  
  async function fetchJob() {
    const res = await fetch(`${baseURL}/api/user/jobs`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    const jobs = await res.json()
    job.value = jobs.find(j => j.id == route.params.jobId)
  }
  
  async function completePayment() {
    // DEMO ödeme işlemi
    const res = await fetch(`${baseURL}/api/user/pay/${route.params.jobId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` }
    })
  
    if (res.ok) {
      alert('Ödeme başarılı!')
      router.push('/')
    } else {
      alert('Ödeme başarısız.')
    }
  }
  
  function formatStatus(status) {
    return {
      waiting: 'Bekliyor',
      price_sent: 'Fiyat Bekliyor',
      waiting_payment: 'Ödeme Bekleniyor',
      in_progress: 'Çeviride',
      completed: 'Tamamlandı'
    }[status] || status
  }
  
  onMounted(fetchJob)
  </script>
  
  <style scoped>
  .payment-box {
  max-width: 600px;
  margin: 40px auto;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.payment-box p {
  margin: 12px 0;
  font-size: 16px;
}

.btn {
  margin-top: 20px;
  padding: 12px 20px;
  background-color: #27ae60;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
}

@media (max-width: 600px) {
  .payment-box {
    margin: 20px 10px;
    padding: 20px;
    border-radius: 10px;
  }

  .payment-box p {
    font-size: 15px;
  }

  h2 {
    font-size: 20px;
    text-align: center;
  }

  .btn {
    font-size: 15px;
    padding: 10px;
  }
}
  </style>
  
